<template>
    <select class="form-control" v-model="selectedProjectId">
        <option :value="null">No project</option>
        <option v-if="!clientId || project.client_id == clientId" v-for="(project, projectId) in projects" :value="project.id">{{project.name}}</option>
    </select>
</template>

<script>

import { mapGetters, mapActions, mapState } from 'vuex';

export default {
  name: 'SelectProject',
  props: ['clientId', 'projectId'],
  data: function () {
    return {
      selectedProjectId: this.projectId,
    };
  },
  watch: {
    selectedProjectId: function (val) {
      this.$emit('input', this.selectedProjectId);
    },
    clientId: function (val) {
      this.selectedProjectId = null;
    }
  },
  computed: {
    ...mapGetters('JiraProjects', ['projects']),
  },
  methods: {

  },
  mounted() {
  },
};
</script>
